import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiClient, SendDepositRequest, SendDepositResult } from '../sdk/sdk';

@Injectable({ providedIn: 'root' })
export class DepositService {
  private readonly sdk = inject(ApiClient);

  sendDepositRequest(request: SendDepositRequest): Observable<SendDepositResult> {
    return this.sdk.sendDeposit(request);
  }
}
